import React, { useState, useEffect, useRef } from "react";
import Layout from "../Layout";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
// import moment from "moment";
import moment from "moment-timezone";

import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  BiChevronLeft,
  BiChevronRight,
  BiPlus,
  BiTime,
  BiUserX,
} from "react-icons/bi";
import { HiOutlineViewGrid } from "react-icons/hi";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import AddAppointmentModal from "../screens/WalkInBooking/AddAppointmentModal";
import bookingApi from "../api/booking/BookingApi";
import toast from "react-hot-toast";
import Loading from "../Util/Loading";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaRegCalendarAlt } from "react-icons/fa"; // Font Awesome
import { BiCalendarEvent } from "react-icons/bi";
import * as Tooltip from "@radix-ui/react-tooltip";
import { ThreeDayView } from "./Threedayview";
import NowIndicatorLabel from "./Calendar/NowIndicator";
import { AiOutlineConsoleSql } from "react-icons/ai";
import { SevenDayView } from "./Calendar/SevendayView";
import staffApi from "../api/staff/staff.api";
import ProcessingBar2 from "../components/ProcessingBar/ProcessingBar2";
import { useNavigate } from "react-router-dom";
import AddBusyTimeModal from "../components/BusyTimeComponent/AddBusyTimeModal";
import busyTimeApi from "../api/staff/busyTimeApi";
import DeleteBusyTimeModal from "../components/BusyTimeComponent/DeleteBusyTimeModal";
import CustomEvent from "./WalkInBooking/CustomEvent";
import { socketId } from "../configs/axiosConfig";
import { useSelector } from "react-redux";
import BookingNotificationModal from "../components/BookingNotification/BookingNotificationModal";

const localizer = momentLocalizer(moment);

const CustomToolbar = (toolbar) => {
  const goToBack = () => toolbar.onNavigate("PREV");
  const goToNext = () => toolbar.onNavigate("NEXT");
  const goToToday = () => toolbar.onNavigate("TODAY");
  const changeView = (view) => toolbar.onView(view);

  return (
    <div className="flex flex-col gap-6 my-6 text-text px-4">
      <h1 className="text-xl font-semibold">Appointments</h1>

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        {/* Date navigation */}
        <div className="flex items-center gap-2 flex-wrap justify-center sm:justify-start">
          <button onClick={goToBack} className="text-xl">
            <BiChevronLeft />
          </button>
          <span className="font-semibold">
            {moment(toolbar.date).format("ddd D MMM")}
          </span>
          <button onClick={goToNext} className="text-xl">
            <BiChevronRight />
          </button>

          <button
            onClick={goToToday}
            className="ml-2 px-3 py-1 border border-redlight rounded text-sm text-redlight"
          >
            Today
          </button>
        </div>

        {/* View buttons with tooltips */}
        <Tooltip.Provider delayDuration={100}>
          <div className="flex gap-2 justify-center sm:justify-end flex-wrap">
            {[
              { icon: <FaRegCalendarAlt />, label: "1 Day", view: "day" },
              // { icon: <BiCalendarEvent />, label: "3 Day", view: "3day" },
              {
                icon: <HiOutlineCalendarDays />,
                label: "Week",
                view: "week",
              },
              { icon: <HiOutlineViewGrid />, label: "Month", view: "month" },
            ].map(({ icon, label, view }) => (
              <Tooltip.Root key={view}>
                <Tooltip.Trigger asChild>
                  <button
                    onClick={() => changeView(view)}
                    aria-label={label}
                    className="p-2 border border-redlight rounded text-redlight hover:bg-redlight hover:text-white transition-colors"
                  >
                    {icon}
                  </button>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    side="top"
                    align="center"
                    sideOffset={6}
                    className="bg-black text-white text-xs px-2 py-1 rounded-md shadow-lg z-50"
                  >
                    {label}
                    <Tooltip.Arrow className="fill-black" />
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            ))}
          </div>
        </Tooltip.Provider>
      </div>
    </div>
  );
};

function Appointments() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [booking, setBooking] = useState([]);
  const [staffResources, setStaffResources] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [busyTimes, setBusyTimes] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingStaff, setIsLoadingStaff] = useState(true);

  const userInfo = useSelector((state) => state?.user?.user);
  const seller = userInfo;

  const [modalOpen, setModalOpen] = useState(false);
  const [orderData, setOrderData] = useState({});

  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    if (!seller?._id) return;

    socketId.emit("addUser", seller._id);

    const handleGetUsers = (data) => {
      setOnlineUsers(data);
      console.log("Updated online users:", data);
    };

    socketId.off("getUsers").on("getUsers", handleGetUsers); // safely replace any existing

    return () => {
      socketId.off("getUsers", handleGetUsers);
    };
  }, [socketId, seller?._id]);

  useEffect(() => {
    socketId.on("getOrderNotification", (data) => {
      setOrderData(data);
      setModalOpen(true);
      console.log("📦 New Order Received:", data);
      // Optional: Show toast or trigger refresh
      // toast.info(`New Order: ${data.orderId}`);
    });

    return () => {
      socketId.off("getOrderNotification");
    };
  }, []);

  const getAllBookings = async () => {
    try {
      const { response } = await bookingApi.getAllBookings();
      if (response && response.data) {
        setBooking(response.data.booking);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching bookings:", error);
    }
  };

  const getAllBusyTimes = async () => {
    try {
      const { response } = await busyTimeApi.getAllBusyTimes();
      if (response && response.data?.data) {
        setBusyTimes(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch busy times");
      console.error("Busy time fetch error:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getAllBookings();
      await getAllBusyTimes(); // ✅

      setIsLoading(false);
    };
    fetchData();
  }, []);

  const fetchAndFormatStaffResources = async () => {
    try {
      const { response } = await staffApi.getAllStaffInfo();

      const staffList = response?.data?.data || [];

      setStaffs(staffList);
      // Filter out deleted staff
      const activeStaff = staffList.filter((staff) => staff.isDelete !== "yes");

      return activeStaff.map((staff) => ({
        resourceId: staff._id,
        resourceTitle: (
          <div className="flex flex-col items-center gap-2 m-4">
            <img
              src={staff.photo}
              alt={staff.name}
              className="w-14 h-14 rounded-full object-cover border-1 border-textGray p-2"
            />
            <span className="uppercase text-center text-xs font-medium">
              {staff.name}
            </span>
          </div>
        ),
        fullInfo: {
          _id: staff._id,
          name: staff.name,
          photo: staff.photo,
        },
      }));
    } catch (error) {
      console.error("Error fetching staff resources:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingStaff(true);
      await getAllBookings();
      const staff = await fetchAndFormatStaffResources(booking);
      setStaffResources(staff);
      setIsLoadingStaff(false);
    };
    fetchData();
  }, []);

  // console.log({ booking });

  // console.log({ staffs });

  function stripTimezone(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
  }

  const parsedEvents = booking.flatMap((item) => {
    const events = [];

    // parse duration from backend (string → number)
    const totalDuration = parseInt(item.totalTimeService || 0, 10);

    // parse the start time using NZ timezone
    const startMoment = moment.tz(
      item.selectedDateTime,
      "YYYY-MM-DD hh:mm A",
      "Pacific/Auckland"
    );

    const endMoment = moment(startMoment).add(totalDuration, "minutes");

    const staff = item.selectedProfessional;
    const user = item.user;

    const baseEventInfo = {
      id: item._id,
      title: item.customer_info?.name || "Appointment",
      customerPhone: item.customer_info?.mobile || "",
      customerPhoto: user?.photo || "",
      customerEmail: item.customer_info?.email || "",
      customerMessage: item.customer_info?.message || "",
      resourceId: staff?._id,
      staffName: staff?.name || "",
      staffPhoto: staff?.photo || "",
      bookingtype: item?.bookingtype,
      bookingStatus: item?.booking?.status || "booked",
      serviceList: item.selectedServices || [],
      totalTimeService: item.totalTimeService || "0", // 👈 keep original "60"
      totalPrice: item.totalPrice ?? 0, // 👈 keep original 57.5
    };

    if (totalDuration > 0) {
      events.push({
        ...baseEventInfo,
        start: startMoment.toDate(),
        end: endMoment.toDate(),
        type: "service",
      });
    }

    return events;
  });

  // console.log({ parsedEvents });

  // break time

  const generateBreakEvents = (staff) => {
    const dayMap = {
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
      Sunday: 0,
    };

    const today = moment().startOf("week");

    return staff.timeslot.flatMap((daySlot) => {
      const dayOffset = dayMap[daySlot.day];
      const date = moment(today).day(dayOffset);

      return (daySlot.breaks || []).map((brk, idx) => ({
        id: `${staff._id}_break_${daySlot.day}_${idx}`,
        title: `Break - ${staff.name}`,
        start: moment(
          `${date.format("YYYY-MM-DD")} ${brk.start}`,
          "YYYY-MM-DD hh:mm A"
        ).toDate(),
        end: moment(
          `${date.format("YYYY-MM-DD")} ${brk.end}`,
          "YYYY-MM-DD hh:mm A"
        ).toDate(),
        resourceId: staff._id,
        isBreak: true,
      }));
    });
  };

  const busyTimeEvents = busyTimes.map((bt) => {
    return {
      id: bt._id,
      title: bt.reason || "Busy",
      start: moment(`${bt.date} ${bt.start}`, "YYYY-MM-DD hh:mm A").toDate(),
      end: moment(`${bt.date} ${bt.end}`, "YYYY-MM-DD hh:mm A").toDate(),
      resourceId: bt.staff._id, // match to staff._id
      isBusy: true,
    };
  });

  // console.log({ busyTimes });

  const allBreakEvents = staffs.flatMap(generateBreakEvents);

  // no work event
  // no work event
  const generateAllDaySlots = (day) => {
    const slots = [];
    const base = moment().startOf("week").day(day); // get correct weekday
    for (let hour = 7; hour < 21; hour++) {
      for (let min = 0; min < 60; min += 30) {
        const start = base.clone().hour(hour).minute(min);
        const end = start.clone().add(30, "minutes");
        slots.push({ start: start.toDate(), end: end.toDate() });
      }
    }
    return slots;
  };

  const combinedEvents = [
    ...parsedEvents,
    ...allBreakEvents,
    ...busyTimeEvents,
  ];

  //auto refresh busy time
  const handleBusyTimeSuccess = async () => {
    await getAllBookings(); // ✅ refresh appointments
    await getAllBusyTimes(); // ✅ refresh busy times
  };

  // new state for the context menu

  const handleClose = () => {
    setOpen(!open);
    setData({});
  };

  const navigate = useNavigate();

  const handleEventClick = (event) => {
    console.log({ event });
    if (event.temp) return;

    if (event.isBusy) {
      setSelectedBusyEvent(event);
      setDeleteModalOpen(true);
      return;
    }

    if (event.isBreak) {
      navigate(`/staff/preview/${event.resourceId}`); // 👈 Navigate to staff profile
      return;
    }

    console.log({ event });
    setData(event);
    setOpen(true);
    // navigate(`/booking/preview/${event.id}`);
  };

  // custom timeslot

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [tempSlotEvent, setTempSlotEvent] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });

  const clickPositionRef = useRef({ x: 0, y: 0 });

  const containerRef = useRef();

  //busy time component
  const [isBusyModalOpen, setIsBusyModalOpen] = useState(false);
  const [busySlotInfo, setBusySlotInfo] = useState(null);

  //delete busytime
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedBusyEvent, setSelectedBusyEvent] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);

  const [selectedDateTime, setSelectedDateTime] = useState(() => {
    if (tempSlotEvent?.start) {
      return moment(tempSlotEvent.start).format("YYYY-MM-DD hh:mm A");
    }
    return null;
  });

  if (isLoading) return <Loading />;

  return (
    <Layout>
      {selectedSlot && (
        <div className="fixed bottom-10 right-10 bg-white shadow-lg border rounded-lg p-4 text-sm text-gray-700 z-50">
          <div className="font-semibold mb-1">Selected Time Slot:</div>
          <div>
            {moment(selectedSlot.start).format("h:mm A")} –{" "}
            {moment(selectedSlot.end).format("h:mm A")}
          </div>
          <button
            onClick={() => setSelectedSlot(null)}
            className="mt-3 text-xs px-3 py-1 bg-red-500 text-white rounded"
          >
            Close
          </button>
        </div>
      )}
      {isLoadingStaff ? (
        <div className="h-screen bg-dry flex items-center justify-center">
          <ProcessingBar2 />
        </div>
      ) : staffs.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-screen text-center text-white scrollbar-thin">
          <div className="flex flex-col items-center justify-center gap-4 p-6 rounded-md bg-dry">
            <BiUserX size={70} className="mb-6 text-redlight" />
            <h2 className="text-lg font-semibold">No Staff Found</h2>
            <p className="text-sm text-gray-400">
              You currently have no staff records. Add a new staff member to get
              started.
            </p>
            <button
              onClick={() => navigate("/staff/create")} // adjust route
              className="mt-4 bg-redlight hover:bg-redlight hover:text-reddark text-black px-5 py-2 rounded-md shadow"
            >
              Add New Staff
            </button>
          </div>
        </div>
      ) : (
        <>
          <div
            className="relative overflow-y-auto  scrollbar-thin scrollbar-thumb-redlight scrollbar-track-gray-200"
            ref={containerRef}
            onClickCapture={(e) => {
              const rect = containerRef.current.getBoundingClientRect();
              clickPositionRef.current = {
                x: e.clientX - rect.left,
                y: e.clientY - rect.top,
              };
            }}
          >
            <Calendar
              localizer={localizer}
              events={[
                ...combinedEvents,
                ...(tempSlotEvent ? [tempSlotEvent] : []),
              ]}
              resources={staffResources}
              resourceIdAccessor="resourceId"
              resourceTitleAccessor="resourceTitle"
              defaultView={Views.DAY}
              views={{
                day: true,
                agenda: true,
                week: true,
                month: true,
                "3day": {
                  ...ThreeDayView,
                  displayName: "Three Day",
                },
                "7day": {
                  ...SevenDayView,
                  displayName: "Full Week",
                },
              }}
              step={30}
              timeslots={2}
              defaultDate={new Date()}
              style={{ height: 1500, marginBottom: 50 }}
              min={new Date(0, 0, 0, 8, 0)}
              max={new Date(0, 0, 0, 22, 0)}
              onSelectEvent={handleEventClick}
              selectable
              onSelectSlot={(slotInfo) => {
                const slotStart = moment(slotInfo.start);
                const slotEnd = moment(slotInfo.end);
                const now = moment();
                if (slotStart.isBefore(now)) return;

                setTempSlotEvent({
                  id: "temp-slot",
                  title: `${slotStart.format("h:mm A")} – ${slotEnd.format(
                    "h:mm A"
                  )}`,
                  start: slotStart.toDate(),
                  end: slotEnd.toDate(),
                  temp: true,
                  resourceId: slotInfo.resourceId, // ✅ REQUIRED
                });

                setContextMenu({
                  top: clickPositionRef.current.y - 10,
                  left: clickPositionRef.current.x + 10,
                  time: slotStart,
                });
              }}
              components={{
                toolbar: CustomToolbar,
                event: CustomEvent,
              }}
              slotPropGetter={(date, resourceId) => {
                const isPast = moment(date).isBefore(moment());
                const dayOfWeek = moment(date).format("dddd"); // e.g., "Monday"
                // const timeStr = moment(date).format("hh:mm A");
                const timeStr = moment(date).format("HH:mm"); // ✅ "09:00", "13:00"

                const staff = staffs.find((s) => s._id === resourceId);
                let isAvailable = false;

                if (staff?.timeslot) {
                  const daySlot = staff.timeslot.find(
                    (slot) => slot.day === dayOfWeek
                  );
                  if (daySlot) {
                    isAvailable = daySlot.slots.some(
                      (s) =>
                        s.start === timeStr &&
                        s.status === "available" &&
                        s.selected === true
                    );
                  }
                }

                const isDisabled = isPast || !isAvailable;

                return {
                  onClick: (e) => {
                    clickPositionRef.current = {
                      x: e.clientX + window.scrollX,
                      y: e.clientY + window.scrollY,
                    };
                  },
                  className: `transition-all duration-200 ${
                    isDisabled
                      ? "pointer-events-none opacity-40 cursor-not-allowed"
                      : "hover:bg-red-200 cursor-pointer"
                  }`,
                  style: {
                    backgroundColor: isAvailable
                      ? "rgba(255, 253, 0, 0.3)"
                      : "transparent", //
                  },
                };
              }}
              eventPropGetter={(event) => {
                const now = moment();
                const isPast = moment(event.end).isBefore(now);
                const isCompleted = event.bookingStatus === "completed";

                if (event.temp) {
                  return {
                    style: {
                      color: "#fff",
                      backgroundColor: "transparent",
                      border: "none",
                      padding: "0px",
                      pointerEvents: "none", // ✅ disables all mouse interactions
                    },
                  };
                }

                if (event.isBreak) {
                  return {
                    style: {
                      backgroundImage: `repeating-linear-gradient(
                        135deg,
                        #9ca3af,
                        #9ca3af 1px,
                        #d1d5db 1px,
                        #d1d5db 20px
                      )`,
                      border: "none",
                      borderRadius: "0px",
                      color: "white",
                      fontSize: "18px",
                      textAlign: "center",
                    },
                  };
                }

                if (event.isBusy) {
                  return {
                    style: {
                      backgroundImage: `repeating-linear-gradient(
                        135deg,
                        #9ca3af,
                        #9ca3af 1px,
                        #d1d5db 1px,
                        #d1d5db 20px
                      )`,
                      border: "none",
                      borderRadius: "0px",
                      color: "white",
                      fontSize: "12px",
                      textAlign: "center",
                    },
                  };
                }

                if (event.bookingStatus === "cancelled") {
                  return {
                    style: {
                      backgroundColor: "#f87171", // red
                      borderLeft: "8px solid #b91c1c", // dark red
                      color: "white",
                      borderRadius: "0px",
                      textDecoration: "line-through", // visually mark it cancelled
                      opacity: 0.7,
                    },
                  };
                }

                if (isPast || isCompleted) {
                  return {
                    style: {
                      backgroundColor: "#d1d5db",
                      borderLeft: "8px solid #9ca3af",
                      borderRadius: "0px",
                      color: "#1f2937",
                      opacity: 0.7,
                      textDecoration: isCompleted ? "line-through" : "none",
                      minHeight: "40px",
                    },
                  };
                }

                if (event.type === "nail") {
                  return {
                    style: {
                      backgroundColor: "#bbf7d0", // green
                      borderLeft: "8px solid #10b981",
                      borderRadius: "0px",
                      color: "#1f2937",
                    },
                  };
                }

                if (event.type === "beauty") {
                  return {
                    style: {
                      backgroundColor: "#dbeafe", // blue
                      borderLeft: "8px solid #3b82f6",
                      borderRadius: "0px",
                      color: "#1f2937",
                    },
                  };
                }

                const hasNail = event.selectedNailServices?.length > 0;
                const hasBeauty = event.selectedBeautyServices?.length > 0;

                let backgroundColor = "#fed693"; // default
                let borderColor = "#facc15";

                if (hasNail && hasBeauty) {
                  backgroundColor = "#f59e0b"; // orange
                  borderColor = "#f97316";
                } else if (hasNail) {
                  backgroundColor = "#bbf7d0"; // green
                  borderColor = "#10b981";
                } else if (hasBeauty) {
                  backgroundColor = "#dbeafe"; // blue for beauty
                  borderColor = "#3b82f6"; // blue stripe
                }

                // ✅ Override with gray if past

                return {
                  style: {
                    backgroundColor,
                    borderLeft: `8px solid ${borderColor}`,
                    borderRadius: "0px",
                    color: "#1f2937", // dark text for contrast
                    padding: "0px",
                    minHeight: "40px",
                  },
                };
              }}
            />
            <NowIndicatorLabel />

            {contextMenu && (
              <>
                <div
                  className="absolute bg-redlight shadow-lg border border-border rounded-md z-50 text-sm text-black"
                  style={{
                    top: containerRef.current
                      ? Math.min(
                          contextMenu.top,
                          containerRef.current.offsetHeight - 100
                        )
                      : contextMenu.top,
                    left: containerRef.current
                      ? Math.min(
                          contextMenu.left,
                          containerRef.current.offsetWidth - 200
                        )
                      : contextMenu.left,
                    width: 200,
                  }}
                >
                  <button
                    onClick={() => {
                      console.log(
                        "✅ Add appointment at",
                        contextMenu.time.toString()
                      );
                      setShowAddModal(true); // ✅ open modal

                      setContextMenu(null);
                      // setTempSlotEvent(null);
                    }}
                    className="w-full text-left px-4 py-2 hover:bg-zinc-900 hover:text-redlight"
                  >
                    Add appointment
                  </button>
                  <button
                    onClick={() => {
                      console.log(
                        "📌 Add busy time at",
                        contextMenu.time.toString()
                      );
                      setBusySlotInfo({
                        start: tempSlotEvent?.start,
                        end: tempSlotEvent?.end,
                        staffId: tempSlotEvent?.resourceId,
                      });
                      setContextMenu(null);
                      setTempSlotEvent(null);
                      setIsBusyModalOpen(true);
                    }}
                    className="w-full text-left px-4 py-2 hover:bg-zinc-900 hover:text-redlight"
                  >
                    Add busy time
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
      <div className="rbc-time-content bg-[#e8f0fc]" />
      <ReactTooltip
        id="event-tooltip"
        place="top"
        opacity={1} // important!
        className="!z-[9999] !bg-dry !text-black !shadow-md !rounded-lg !px-3 !py-1 !text-xs"
        delayShow={100}
        clickable
      />
      <AddBusyTimeModal
        isOpen={isBusyModalOpen}
        onClose={() => setIsBusyModalOpen(false)}
        staffId={busySlotInfo?.staffId}
        start={busySlotInfo?.start}
        end={busySlotInfo?.end}
        onSuccess={handleBusyTimeSuccess}
      />
      <DeleteBusyTimeModal
        isOpen={deleteModalOpen}
        event={selectedBusyEvent}
        onClose={() => setDeleteModalOpen(false)}
        onDelete={async () => {
          await getAllBusyTimes(); // Refresh busy times
        }}
      />
      <AddAppointmentModal
        isOpen={showAddModal}
        closeModal={() => {
          setShowAddModal(false);
          setTempSlotEvent(null); // ✅ safe now
        }}
        slotInfo={tempSlotEvent}
        staffs={staffs}
        refreshData={async () => {
          await getAllBookings();
          await getAllBusyTimes();
        }}
      />

      <BookingNotificationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        orderId={orderData.orderId}
        orderInfo={orderData.orderInfo}
      />
    </Layout>
  );
}

export default Appointments;
